export type TrafficDriverFilters = {
    key: string;
    valueList: string[];
};

function isFilterValid(filter: any): filter is TrafficDriverFilters {
    return filter?.key && Array.isArray(filter?.valueList);
}

export function decodeFiltersParam(param: string | null | undefined): TrafficDriverFilters[] {
    if (!param) return [];
    try {
        const decodedParam = decodeURIComponent(param);
        const parsedParam = JSON.parse(decodedParam);
        if (!Array.isArray(parsedParam)) return [];

        const validFilters = parsedParam.filter(isFilterValid);

        return validFilters;
    } catch (e) {
        console.warn(e);
        return [];
    }
}
